// extracted by mini-css-extract-plugin
export var editInput = "_ho-0";
export var editInputCompact = "_ho-2";
export var editInputLarge = "_ho-1";
export var editInputSmall = "_ho-3";